import React, { useEffect, useState, useContext } from "react";
import studyReportContext from "../../../../../context/studyreport/StudyReportContext";
import NewReport from "../../../../Report/NewReport";
import ModalMain from "../../../../../components/Modal/ModalMain";
import ModalHeader from "../../../../../components/Modal/ModalHeader";
import LoadingBar from "react-top-loading-bar";
import { Spinner, SpinnerSize } from "@fluentui/react";
import { t } from "i18next";
import AgenticReportingContext from "../../../../../context/agentic-reporting/AgenticReportingContext";

const ExternalReporting = () => {
  const {
    setStudyParentId,
    openReportModal,
    setOpenReportModal,
    setIsExternal,
    modalityReport,
    showSubmitTick,
    openRSNAModal,
    regenerateClick,
    RSNAModalContent,
    setOpenRSNAModal,
    alertSuccessModal,
    setAlertSuccessModal,
    hideAlertSuccessModal,
    studyPatientDetails,
    externalReportingModalRef,
    externalReportingLoading,
    setExternalReportingLoading,
    updateRowSubmitDone,
    setUpdateDoneSubmitDone,
  } = useContext(studyReportContext);

  const { vapiFunctions, resetAgenticState } = useContext(
    AgenticReportingContext,
  );

  useEffect(() => {
    setExternalReportingLoading(true);
    if (externalReportingModalRef.current != null)
      externalReportingModalRef.current.continuousStart();
  }, [externalReportingModalRef]);

  // Cleanup microphone and state whenever the modal closes (via cancel, submit, or backdrop click)
  useEffect(() => {
    if (!openReportModal) {
      if (vapiFunctions && vapiFunctions.stopAssistant) {
        vapiFunctions.stopAssistant(true);
      }
      if (resetAgenticState) resetAgenticState();
    }
  }, [openReportModal, vapiFunctions, resetAgenticState]);

  useEffect(() => {
    setUpdateDoneSubmitDone({ id: null, show: false });
  }, []);

  useEffect(() => {
    console.log("---- External Loading ---", externalReportingLoading);
    if (externalReportingModalRef.current != null) {
      if (!externalReportingLoading) {
        externalReportingModalRef.current.complete();
      }
    }
  }, [externalReportingLoading]);

  const spinnerStyle = {
    circle: {
      height: "30px",
      width: "30px",
      borderWidth: "3px",
    },
    label: {
      color: "white",
    },
  };

  const modalDetails = {
    header: (
      <ModalHeader
        updatedModal={true}
        heading={t("heading.report")}
        // handleCancel={() => {setIsExternal(false);setOpenReportModal(false)}}
        handleCancel={() => {
          setIsExternal(false);
          setOpenReportModal(false);
          if (vapiFunctions && vapiFunctions.stopAssistant) {
            vapiFunctions.stopAssistant(true);
          }
          if (resetAgenticState) resetAgenticState();
        }}
      />
    ),
    footer: <></>,
    body: (
      //     <div style={{backgroundColor:'black'}}>
      //       <div
      //   style={{
      //     padding: "auto",
      //     height: "100%",
      //     width: "100%",
      //     zIndex: "99999",
      //     display: `${externalReportingLoading ? "flex" : "none"}`,
      //     flexDirection: "column",
      //     justifyContent: "center",
      //     alignItems: "center",
      //     backgroundColor: "black",
      //     opacity:  "0.8",
      //     position: "absolute",
      //     top: "0",
      //     left: "0",
      //   }}
      // >
      //   {externalReportingLoading && <div className="study-list-spinner">
      //       <Spinner
      //         styles={spinnerStyle}
      //         label="Processing..."
      //         size={SpinnerSize.large}
      //       />
      //     </div>}
      //   <LoadingBar
      //     ref={externalReportingModalRef}
      //     color="#0085FF"
      //     height={5}
      //     // progress={progress}
      //     onLoaderFinished={() => {
      //       setExternalReportingLoading(false);
      //     }}
      //     containerStyle={{
      //       backgroundColor: "black",
      //       opacity: "0.8",
      //       position: "absolute",
      //       top: "0",
      //       left: "0",
      //     }}
      //     loaderSpeed={1000}
      //     transitionTime={1000}
      //   />
      // </div>
      <NewReport
        modality={modalityReport}
        showPathologyOptions={false}
        customHeight={500}
        qcData={null}
        keyImages={0}
        annotationData={null}
        activeViewportIndex={null}
        isStudyList={true}
        patientId={studyPatientDetails.patientId}
        patientName={studyPatientDetails.patientName}
      />
      // </div>
    ),
    width: "850px",
    height: window.innerWidth <= 1200 ? "900px" : "700px",
  };

  return (
    <>
      <ModalMain
        showModal={openReportModal}
        modalDetails={modalDetails}
        updatedModal={true}
        //styles={modalReportStyles}
      />
    </>
  );
};

export default ExternalReporting;
